import { pxToRem, TabContent, TabNav, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledTabNav = styled(TabNav) `
  margin: 0 ${theme.spacing['7xl']};
`;
export const StyledTabContent = styled(TabContent) `
  margin: ${theme.spacing['2xl']} ${theme.spacing['7xl']} 0;
  overflow-y: auto;
  min-height: ${pxToRem(200)};
`;
export const HTMLPreviewContainer = styled.div `
  [data-placeholder] {
    color: ${theme.semantic.foreground.primary};

    &::after {
      content: '[' attr(data-placeholder) ']';
      padding: ${pxToRem(1)};
      background-color: ${theme.swatches.yellow[200]};
      border-radius: ${pxToRem(1)};
    }
  }
`;
